import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f8a505f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "appearance-block" }
const _hoisted_2 = {
  key: 0,
  class: "title_green"
}
const _hoisted_3 = {
  key: 1,
  class: "title_green"
}
const _hoisted_4 = {
  key: 0,
  class: "appearance-block-wrapper"
}
const _hoisted_5 = { class: "appearance-block__element" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "appearance-block__title" }, " Цвет волос ", -1 /* HOISTED */))
const _hoisted_7 = { class: "appearance-block__element" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "appearance-block__title" }, " Интимная стрижка ", -1 /* HOISTED */))
const _hoisted_9 = { class: "options" }

import {onMounted, ref, Ref} from 'vue';
import pSelect from '@/common/pSelect/pSelect.vue'
import pCheckbox from '@/common/pCheckbox/pCheckbox.vue';
import { useSearchStore } from "@/searchSection/store/searchStore";
import { IntimHaircut } from "@/searchSection/types/IntimHaircut";
import api from '@/myProfileSection/api';
import HairColorInterface from '@/myProfileSection/types/HairColorInterface';
import ArrowIcon from '@/common/icons/ArrowIcon.vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'AppearanceBlock',
  props: {
    visibleFiltersAppearance: { type: Boolean }
  },
  emits: ['toggleFilter'],
  setup(__props: any, { emit: __emit }) {


const emit = __emit;
const searchStore = useSearchStore()

const hairColors: Ref<HairColorInterface[]> = ref([{
  id: 0,
  name: 'Любой',
}]);

onMounted(async () => {
  const hairColorsResponse = await api.getHairColors()
  hairColorsResponse.forEach(c => hairColors.value.push({id: hairColors.value.length, name: c.name}))
})

const intimHaircutDescription = {
  0: 'Любая',
  [IntimHaircut.Neat]: 'Аккуратная стрижка',
  [IntimHaircut.Depilation]: 'Полная депиляция',
  [IntimHaircut.Natural]: 'Натуральная',
}

const intimHaircuts = Object.keys(intimHaircutDescription).map(keyHair => ({
  id: Number(keyHair),
  name: intimHaircutDescription[keyHair]
}))


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", {
      class: "appearance-block__title title",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('toggleFilter')))
    }, [
      _createTextVNode(" Внешность "),
      (_unref(searchStore).appearanceFilters)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, " Указаны " + _toDisplayString(_unref(searchStore).appearanceFilters) + " параметр ", 1 /* TEXT */))
        : (_openBlock(), _createElementBlock("span", _hoisted_3, "Не указаны")),
      _createVNode(ArrowIcon, {
        class: _normalizeClass(["title__arrow", { 'title__arrow_active': _ctx.visibleFiltersAppearance }])
      }, null, 8 /* PROPS */, ["class"])
    ]),
    _createVNode(_Transition, { name: "fade-slide" }, {
      default: _withCtx(() => [
        (_ctx.visibleFiltersAppearance)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(pSelect, {
                  class: "appearance-block__input",
                  selectionItems: hairColors.value,
                  modelValue: _unref(searchStore).searchOptions.appearanceInfo.hairColor,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(searchStore).searchOptions.appearanceInfo.hairColor) = $event))
                }, null, 8 /* PROPS */, ["selectionItems", "modelValue"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createVNode(pSelect, {
                  class: "appearance-block__input",
                  selectionItems: _unref(intimHaircuts),
                  modelValue: _unref(searchStore).searchOptions.appearanceInfo.intimHaircut,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(searchStore).searchOptions.appearanceInfo.intimHaircut) = $event))
                }, null, 8 /* PROPS */, ["selectionItems", "modelValue"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(pCheckbox, {
                  modelValue: _unref(searchStore).searchOptions.withTattoo,
                  label: "Татуировки",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_unref(searchStore).searchOptions.withTattoo = !_unref(searchStore).searchOptions.withTattoo))
                }, null, 8 /* PROPS */, ["modelValue"]),
                _createVNode(pCheckbox, {
                  modelValue: _unref(searchStore).searchOptions.withPiercing,
                  label: "Пирсинг",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_unref(searchStore).searchOptions.withPiercing = !_unref(searchStore).searchOptions.withPiercing))
                }, null, 8 /* PROPS */, ["modelValue"]),
                _createVNode(pCheckbox, {
                  modelValue: _unref(searchStore).searchOptions.withSiliconeBreast,
                  label: "Силиконовая грудь",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_unref(searchStore).searchOptions.withSiliconeBreast = !_unref(searchStore).searchOptions.withSiliconeBreast))
                }, null, 8 /* PROPS */, ["modelValue"])
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}
}

})